import { useDailyProgressCardQuery } from 'core/graphql/DailyProgress/DailyProgress.generated';
import { DailyProgress, DeliveryStatistics } from 'core/graphql/types';

type DailyProgressResult = {
  dailyProgress: DailyProgress | null | undefined;
  deliveryStatistics: DeliveryStatistics | null | undefined;
  loading: boolean;
  refresh: () => Promise<void>;
};

const useDailyProgressCardDataStore = (
  date: string | null,
  courierId: number | null,
): DailyProgressResult => {
  const { data, loading, refetch } = useDailyProgressCardQuery({
    skip: !date || !courierId,
    variables:
      date && courierId
        ? {
            date,
            courierId,
          }
        : undefined,
  });

  const refresh = async () => {
    await refetch(
      date && courierId
        ? {
            date,
            courierId,
          }
        : undefined,
    );
  };

  if (data) {
    return {
      dailyProgress: data.DailyProgressByCourierIdAndDate,
      deliveryStatistics: data.DeliveriesStatisticsByCourierIdAndDate,
      loading,
      refresh,
    };
  }

  return {
    loading,
    dailyProgress: null,
    deliveryStatistics: null,
    refresh,
  };
};

export default useDailyProgressCardDataStore;
